module.exports = __webpack_public_path__ + "static/media/Clock.3dc7a403.svg";